export enum TipoFiltroProyecto {
    PROYECTO,
    ETAPA,
    LIDER,
    CLIENTE,
}


export namespace TipoFiltroProyecto {
    export function values() {
      return Object.keys(TipoFiltroProyecto).filter(
        (type) => Number.isNaN(Number(type)) && type !== 'values'
      );
    }
  }